

















































import { Component, Prop, Vue, namespace } from 'nuxt-property-decorator'
import { mdiWarehouse } from '@mdi/js'
import LazyHydrate from 'vue-lazy-hydration'
import { filterPrice } from '~/assets/filters/price'
import { ICity } from '~/assets/interfaces/location'
import { IStyle } from '~/assets/interfaces/classes'
import { PRODUCTS_API } from '~/assets/config/api-path'
import { filterUrl } from '~/assets/filters/url'
const siteStore = namespace('site')
interface IDeliveryItemInProduct {
  title: string
  date: string
  price: number | null
  priceDescription?: string
}
@Component({
  components: {
    LazyHydrate,
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentPopupPreloader: () => import('~/components/popup/preload.vue'),
    componentLocationCitySelection: () =>
      import('~/components/location/city-selection.vue'),
  },
})
export default class ComponentDelivery extends Vue {
  @siteStore.Getter('getOptionsCurrency') private getOptionsCurrency!: string
  @Prop({ type: Number }) readonly productId!: number

  private icons = {
    mdiWarehouse,
  }

  @siteStore.Getter('getLocationName') private locationName!: string | null
  @siteStore.State('location') private location!: ICity | null
  @siteStore.Action('setLocation') private setLocation!: (
    city: ICity
  ) => Promise<void>

  private isComponentCitySelectionLoaded = false
  private isOpenPopup = false
  private text = ''
  private items: IDeliveryItemInProduct[] = []
  private filterPrice(item: IDeliveryItemInProduct) {
    if (item.price === 0) {
      return 'бесплатно'
    }
    if (item.price === null) {
      return item.priceDescription || ''
    }
    return filterPrice(item.price)
  }

  private async locationSelect(location: ICity) {
    await this.setLocation(location)
    this.isOpenPopup = false
    this.$emit('changeLocation')
  }

  private $style!: IStyle

  private get classDelivery() {
    return {
      [this.$style.delivery]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }

  private async created() {
    const response = await this.$axios.$get(
      filterUrl(PRODUCTS_API + '/' + this.productId + '/delivery')
    )
    this.items = response.items
    this.text = response.text || ''
  }
}
